module.exports = __webpack_public_path__ + "error_icon.e0fb12a8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/error_icon.svg
 ** module id = 988
 ** module chunks = 0
 **/